import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Box, Button, TableCell, Typography } from "@mui/material";
import React from "react";

import ShipperAPI from "../api/Shipper.api";
import BasicCreateModal from "../components/BasicCreateModal";
import Layout from "../components/Layout";
import ListModel from "../components/ListModel";
import { Shipper, TableColumn } from "../types";
import { extractDate } from "../utils";

const columns: TableColumn<Shipper>[] = [
  { field: "name", label: "Name" },
  { field: "createdAt", label: "Created At Date" },
];

function buildTableRow(shipper: Shipper): JSX.Element[] {
  return [
    <TableCell key={"name"}>{shipper.name}</TableCell>,
    <TableCell key={"createdAt"}>{extractDate(shipper.createdAt)}</TableCell>,
  ];
}

export default function ShipperList() {
  const [openModel, setOpenModal] = React.useState<boolean>(false);
  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">Shippers</Typography>
          <Button onClick={() => setOpenModal(true)}>
            <AddCircleIcon />
          </Button>
        </Box>

        <ListModel
          defaultOrderBy={"name"}
          modelApiUseList={ShipperAPI.useList}
          modelBaseUrl={"shippers"}
          columns={columns}
          buildTableRow={buildTableRow}
        />
        <BasicCreateModal
          open={openModel}
          onClose={() => setOpenModal(false)}
          modelApiUseSave={ShipperAPI.useSave}
          navigateUrl="/shippers"
        />
      </Box>
    </Layout>
  );
}
